var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterTSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2665",
    "data-name": "Group 2665",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 17.973,
    viewBox: "0 0 18 17.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1787",
    "data-name": "Rectangle 1787",
    width: 18,
    height: 17.973,
    fill: "#610D24"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2664",
    "data-name": "Group 2664",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3728",
    "data-name": "Path 3728",
    d: "M1.285,0A1.285,1.285,0,0,0,0,1.284V2.571A1.285,1.285,0,0,0,1.285,3.852H7.071V16.687a1.285,1.285,0,0,0,1.285,1.285H9.643a1.285,1.285,0,0,0,1.285-1.285V3.852h5.786A1.285,1.285,0,0,0,18,2.567V1.29A1.285,1.285,0,0,0,16.721,0H1.285",
    transform: "translate(0 0.001)",
    fill: "#610D24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterTSelected);
export default __webpack_public_path__ + "static/media/letter_t_selected.7a3e1acc4785ef140f0b700050ad0b66.svg";
export { ForwardRef as ReactComponent };